import Layout from "./components/Layout";
import { useEffect, useState } from "react";
import API from "../../services/API";
import { Link, useParams } from "react-router-dom";
import Loader from "../Tools/Loader";
import Chat from "../Tools/Chat";
import { Alert, Button, Stack } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export default function Opco(){

    const { id } = useParams()

    const [status, setStatus] = useState('loading')

    useEffect(() => {

        API.get(`/courses/${id}/opco`)
            .then(_ => setStatus('success'))

    }, [id])

    return (
        <Layout center>

            {status === 'loading' &&
                <Loader />
            }

            {status === 'success' &&
                <Stack spacing={2} sx={{maxWidth: 600, margin: 'auto'}}>
                    
                    <Alert severity="success">
                        Notre service client a été informé de votre souhait de financement par l'OPCO. Vous serez recontacté sous peu.
                    </Alert>

                    <Button startIcon={<ArrowBack />} component={Link} to="/">
                        Retourner à l'accueil
                    </Button>

                </Stack>
            }

            <Chat />

        </Layout>
    );
}